import { render } from "./feature-card.vue?vue&type=template&id=12853762&scoped=true&ts=true"
import script from "./feature-card.vue?vue&type=script&lang=ts"
export * from "./feature-card.vue?vue&type=script&lang=ts"

import "./feature-card.vue?vue&type=style&index=0&id=12853762&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12853762"]])

export default __exports__